module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('md-list-item', {
    staticClass: "ql-project-bookmark-item-wrapper",
    class: {
      'ql-project-bookmark-current': Number(_vm.page) === Number(_vm.currentPage)
    }
  }, [_c('div', {
    staticClass: "ql-project-bookmark-item",
    on: {
      "click": _vm.gotoPage,
      "dblclick": _vm.edit
    }
  }, [(_vm.versionID) ? _c('span', {
    staticClass: "bookmarkLabel"
  }, [_c('md-icon', {
    staticClass: "bookmarkIcon"
  }, [_vm._v("bookmark_border")]), _vm._v("\n            p. " + _vm._s(_vm.currentVersion.pdfPageNumbers && _vm.currentVersion.pdfPageNumbers[_vm.page - 1] && _vm.currentVersion.pdfPageNumbers[_vm.page - 1].name) + "\n        ")], 1) : _c('span', {
    staticClass: "bookmarkLabel"
  }, [_c('md-icon', {
    staticClass: "bookmarkIcon"
  }, [_vm._v("bookmark_border")]), _vm._v("\n            p. " + _vm._s(_vm.project.pdfPageNumbers && _vm.project.pdfPageNumbers[_vm.page - 1] && _vm.project.pdfPageNumbers[_vm.page - 1].name) + "\n        ")], 1), _vm._v(" "), (!_vm.editing) ? _c('div', {
    staticClass: "bookmarkTitle"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), (_vm.editing) ? _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.saveTitle.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      }
    }
  }, [_c('md-input-container', [_c('md-input', {
    ref: "input_title",
    on: {
      "blur": _vm.done,
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.oldTitle),
      callback: function($$v) {
        _vm.oldTitle = $$v
      },
      expression: "oldTitle"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-tooltip', [_vm._v("Double Click to Edit")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00f8ff6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/bookmark/bookmark.vue
// module id = 1197
// module chunks = 21